import {StatusIcons} from "assets/icons/status/status.index";
import theme from "theme/theme";
import {en} from "language/en";
import {StatusItem} from "assets/arrayList/ProjectStatus";

const enTask = en.screen.Task.status;

const submitted: StatusItem = {
  title: enTask.submitted,
  icon: StatusIcons.Submitted,
  color: theme.palette.secondary.main,
  checked: false,
}

export default submitted